// extracted by mini-css-extract-plugin
export default {"switch-container":"AutoBetToggle_switch-container__yDy0A","checkbox":"AutoBetToggle_checkbox__sQeGw","switch":"AutoBetToggle_switch__7mgE2","slider":"AutoBetToggle_slider__L57Np"};